// extracted by mini-css-extract-plugin
export var menuLink = "account-module--menu-link--uq7rT";
export var submenuLink = "account-module--submenu-link--OAFUq";